
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.439 40H8.56C3.841 40 0 36.159 0 31.439V8.56C0 3.841 3.841 0 8.561 0H31.44C36.159 0 40 3.841 40 8.561V31.44C40 36.159 36.159 40 31.439 40zM8.56 1.557A7.012 7.012 0 001.557 8.56V31.44a7.012 7.012 0 007.004 7.004H31.44a7.012 7.012 0 007.004-7.004V8.56a7.012 7.012 0 00-7.004-7.004H8.56z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.848 11.48c1.567.263 3.093.728 4.538 1.382 2.49 3.603 3.727 7.667 3.27 12.354a18.273 18.273 0 01-5.57 2.764 13.12 13.12 0 01-1.192-1.9 11.8 11.8 0 001.881-.889 6.564 6.564 0 01-.46-.342 13.203 13.203 0 01-11.13 0c-.149.113-.303.23-.46.342.598.35 1.226.647 1.877.887a13.301 13.301 0 01-1.192 1.902 18.347 18.347 0 01-5.567-2.765c-.389-4.043.39-8.143 3.262-12.35a18.54 18.54 0 014.542-1.385c.215.38.409.771.581 1.17a17.112 17.112 0 015.038 0c.173-.4.367-.79.582-1.17zm-8.734 9.075c0 1.2.896 2.174 1.982 2.174 1.085 0 1.96-.975 1.979-2.174.019-1.198-.87-2.181-1.983-2.181s-1.978.983-1.978 2.181zm7.311 0c0 1.2.893 2.174 1.98 2.174 1.086 0 1.958-.975 1.977-2.174.02-1.198-.863-2.181-1.978-2.181-1.114 0-1.979.983-1.979 2.181z","fill":"#fff"}})])
          )
        }
      }
    